import React, {useState} from 'react';
import { connect } from 'react-redux';
import {getIsFormValidating} from "../../selectors";
import {changeTermsStatusAction, validateForm} from "../../reducers";

const stateToProps = state => ({
    isFormValidating: getIsFormValidating(state),
});

const actionsToProps = dispatch => ({
    validateForm: payload => dispatch(validateForm(payload)),
    changeTermsStatus: payload => dispatch(changeTermsStatusAction(payload)),
});

const TermsAndConditions = props => {

    const [enableAccept, setEnableAccept] = useState(false);

    return (
        <div className="form-row">
            <div className="terms">
                <p className="terms__title">Terms and Conditions</p>
                <p className="mt10">
                    All new Bet9ja Online Customers registered in shops who successfully deposit using Paystack,
                    Webpay and/or any of the following methods, Instant Bank Deposits, UBA EmailMoni Deposit,
                    GT Bank Online/Mobile Transfer, ATM Deposit, Quickteller, Opay, Polaris Mobile Deposit and
                    Providus Bank Collect Pro App will be eligible for the 100% Welcome Bonus. The Customer must
                    make a successful first deposit (minimum deposit NGN100) into their Bet9ja account using any
                    of the above-mentioned deposit methods to qualify. Subsequent deposits will not count for this offer.
                </p>
            </div>

            <div className="accept-terms">
                <strong>Accept Terms <span className="asterisk">*</span></strong>

                <div className="checkbox mt10">
                    <input id="chk-1" disabled={props.isFormValidating} type="checkbox" onChange={e => {
                        setEnableAccept(!enableAccept);
                        props.changeTermsStatus(e.target.checked ? 'success' : '');
                    }} />

                    <label htmlFor="chk-1" className="checkbox__content" >
                        <div className="checkbox__box" />
                        <span className="checkbox__label">I agree to the Terms and Conditions.</span>
                    </label>
                </div>
            </div>
        </div>
    );
}

export default connect(
    stateToProps,
    actionsToProps
)(TermsAndConditions);
